import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=792e175b&scoped=true&lang=pug&"
import script from "./BackButton.vue?vue&type=script&lang=coffee&"
export * from "./BackButton.vue?vue&type=script&lang=coffee&"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=792e175b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792e175b",
  null
  
)

export default component.exports